const TAB_TYPES = {
  CLASSIFICATIONS: 'classifications',
  ROOT_LESS: 'root_less',
  GOALS: 'goals'
}

export {
  TAB_TYPES
}